import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import cookie from "react-cookies";
import { connect } from "react-redux";
import { Modal } from "react-bootstrap";

import { getAddressFromLatLng, searchInHouse, searchLocations } from "../../model/common";
import { getListAddressOfUser } from "../../model/profile";

import { commonErr } from "./errors";
import { getHereAddress } from "./common";
import { MessageBox } from "./messagebox";
import { LoadingInline } from "./loading";

import { IcCloseOrange, IcSuggestHome, IcSuggestPlane, IcSuggestSearch } from "./svg";

const LocationDefault = ({ sd, session, errMyPosition, selectLocation, getCurrentAddress }) => {
	const [address, setAddress] = useState();
	const [errAddress, setErrAddress] = useState(commonErr.LOADING);
	const [airports, setAirports] = useState([]);
	const [errAirports, setErrAirports] = useState(commonErr.LOADING);
	const [histories, setHistories] = useState([]);
	const [errHistories, setErrHistories] = useState(commonErr.LOADING);

	useEffect(() => {
		if (session.profile?.info?.uid) {
			getListAddressOfUser().then((resp) => {
				if (resp.data.error >= commonErr.SUCCESS && resp.data.data) {
					const defaultAddress = resp.data.data.addresses?.find((address) => address.isDefault);
					setAddress(defaultAddress);
				}
				setErrAddress(commonErr.SUCCESS);
			});
		} else {
			setErrAddress(commonErr.SUCCESS);
		}

		searchLocations(sd ? 1 : 2).then((resp) => {
			setErrAirports(commonErr.SUCCESS);
			if (resp.data.error >= commonErr.SUCCESS && resp.data.data) {
				setAirports(resp.data.data.locations);
			}
		});

		const historiesList = [];
		for (let i = 0; i < 10; i++) {
			//parse string to array ( address | lat | lng )
			const history = cookie.load(`_mhistory${i}`);
			if (history !== undefined) {
				const parseHistory = history.split("|");
				historiesList.unshift({ label: parseHistory[0], lat: parseHistory[1], lon: parseHistory[2] });
			}
		}
		setErrHistories(commonErr.SUCCESS);
		setHistories(historiesList);
	}, []);

	return (
		<>
			<div className="box-container">
				{errMyPosition === commonErr.LOADING ? (
					<div className="wrap-box" style={{ height: "40px" }}>
						<LoadingInline />
					</div>
				) : (
					<div className="wrap-box">
						<div className="box-item" onClick={() => getCurrentAddress()}>
							<div className="wrap-svg">
								<IcSuggestSearch />
							</div>
							<div className="box-item__text">
								<p className="main">Vị trí hiện tại</p>
							</div>
						</div>
					</div>
				)}
			</div>
			{errAddress === commonErr.LOADING ? (
				<div className="box-container marginTop-m">
					<LoadingInline />
				</div>
			) : (
				<>
					{address && (
						<div className="box-container">
							<p className="title-box">Địa chỉ của tôi</p>
							<div className="wrap-box">
								<div className="box-item" onClick={() => selectLocation(address, 1)}>
									<div className="wrap-svg">
										<IcSuggestHome />
									</div>
									<div className="box-item__text">
										<p className="main">{address.addressName}</p>
										<p>
											{address.street}, {address.wardName}, {address.districtName}, {address.cityName}
										</p>
									</div>
								</div>
							</div>
						</div>
					)}
				</>
			)}
			{errAirports === commonErr.LOADING ? (
				<div className="box-container marginTop-m">
					<LoadingInline />
				</div>
			) : (
				<>
					{airports.length > 0 && (
						<div className="box-container">
							<p className="title-box">Giao xe sân bay</p>
							<div className="wrap-box airport">
								{airports.map((airport) => (
									<div className="box-item" key={airport.id} onClick={() => selectLocation(airport, 2)}>
										<div className="wrap-svg">
											<IcSuggestPlane />
										</div>
										<div className="box-item__text">
											<p className="main">{airport.name}</p>
										</div>
									</div>
								))}
							</div>
						</div>
					)}
				</>
			)}
			{errHistories === commonErr.LOADING ? (
				<div className="box-container marginTop-m">
					<LoadingInline />
				</div>
			) : (
				<>
					{histories.length > 0 && (
						<div className="box-container">
							<p className="title-box">Tìm kiếm gần đây</p>
							<div className="wrap-box">
								{histories.map((his) => (
									<div key={his.label} className="box-item" onClick={() => selectLocation(his)}>
										<div className="wrap-svg">
											<IcSuggestSearch />
										</div>
										<div className="box-item__text">
											<p className="main">{his.label}</p>
											{/* <p>Đường Vo Van Tan, phường Vo Thi Sau, quận 3, thành phố Hồ Chí Minh</p> */}
										</div>
									</div>
								))}
							</div>
						</div>
					)}
				</>
			)}
		</>
	);
};

const LocationSearch = ({ location, selectLocation }) => {
	const handlePress = async () => {
		await selectLocation(location);
	};
	const address = getHereAddress(location.address);

	return (
		<div className="location-item" onClick={handlePress}>
			<div className="wrap-svg">
				<IcSuggestSearch />
			</div>
			<p>{address}</p>
		</div>
	);
};

const SuggestContent = ({
	onHide,
	sd,
	getDeliveryAirportId,
	getDeliveryAirportWDId,
	hidden,
	focusAddress,
	locAddress,
	inputProps,
	onSelect,
	carFinding,
	session,
	...props
}) => {
	const timeSearch = useRef();
	const historyAddress = useRef([]);

	const [errMyPosition, setErrMyPosition] = useState(commonErr.SUCCESS);
	const [query, setQuery] = useState("");
	const [locationResults, setLocationResults] = useState([]);
	const [currentPosFailed, setCurrentPosFailed] = useState(false);

	useEffect(() => {
		if (inputProps) {
			setQuery(inputProps.value);
		}

		//Load History Addresses
		for (let i = 0; i < 10; i++) {
			const history = cookie.load(`_mhistory${i}`);
			if (history !== undefined) {
				historyAddress.current.push(history);
			}
		}
	}, []);

	const onQuery = (e) => {
		const query = e.target.value;
		let lat, lng;
		if (focusAddress) {
			lat = carFinding.filter.lat;
			lng = carFinding.filter.lng;
		} else if (locAddress) {
			// get from carDetail && locationDelivery
			lat = locAddress.lat;
			lng = locAddress.lng;
		}
		setQuery(query);
		if (query.length === 0) setLocationResults([]);

		if (timeSearch.current) clearTimeout(timeSearch.current);
		timeSearch.current = setTimeout(() => {
			if (query.length >= 3) {
				searchInHouse(query, lat, lng).then((res) => {
					if (res?.data?.data?.locations) {
						const { locations } = res.data.data;
						let ret = [];

						for (let i = 0; i < locations.length; i++) {
							let location = locations[i];
							let data = {
								id: location.subId,
								address: location.address,
								label: location.address,
								lat: location.lat,
								lon: location.lon,
							};
							ret.push(data);
						}
						setLocationResults(ret);
					}
				});
			}
		}, 500);
	};

	const saveHistoryAddressCookie = (address, lat, lng) => {
		const strHistoryAddress = `${address}|${lat}|${lng}`;
		if (historyAddress.current.map((arr) => arr.split("|").includes(address)).includes(true)) {
			const lastHistoryAddress = historyAddress.current.splice(historyAddress.current.indexOf(strHistoryAddress), 1);
			historyAddress.current = historyAddress.current.concat(lastHistoryAddress);
			for (let i = 0; i < historyAddress.current.length; i++) {
				cookie.remove(`_mhistory${i}`, { path: "/" });
				cookie.save(`_mhistory${i}`, historyAddress.current[i], { path: "/" });
			}
		} else {
			historyAddress.current.push(strHistoryAddress);
			if (historyAddress.current.length > 10) {
				historyAddress.current.shift();
			}
			for (let i = 0; i < historyAddress.current.length; i++) {
				cookie.remove(`_mhistory${i}`, { path: "/" });
				cookie.save(`_mhistory${i}`, historyAddress.current[i], { path: "/" });
			}
		}
	};

	const onSelectLocation = (location, type) => {
		//type
		// 0: address from search & history & current position --- DEFAULT
		// 1: address from my address list
		// 2: address from airport list
		const addressQuery =
			type === 1
				? `${location.street}, ${location.wardName}, ${location.districtName}, ${location.cityName}`
				: type === 2
				? location.name
				: location.label;
		if (location?.lat && location?.lon) {
			let address = {
				address: addressQuery,
				lat: location.lat,
				lng: location.lon,
			};
			onSelect(address);
			setQuery(addressQuery);
			//save history address when search is done (not saved airport address)
			if (type !== 2) {
				saveHistoryAddressCookie(addressQuery, location.lat, location.lon);
				if (getDeliveryAirportId) {
					getDeliveryAirportId(0);
				} else if (getDeliveryAirportWDId) {
					getDeliveryAirportWDId(0);
				}
			} else {
				if (getDeliveryAirportId && sd) {
					getDeliveryAirportId(location.id);
					cookie.remove(`_mairport`, { path: "/" });
					cookie.save(`_mairport`, `${location.name}|${location.id}`, { path: "/" });
				} else if (getDeliveryAirportWDId) {
					getDeliveryAirportWDId(location.id);
					cookie.remove(`_mairportWD`, { path: "/" });
					cookie.save(`_mairportWD`, `${location.name}|${location.id}`, { path: "/" });
				}
			}
		} else {
			axios
				.get("https://geocoder.ls.hereapi.com/6.2/geocode.json", {
					params: {
						apiKey: "xbdotv2bSiK72Tq4E5hwyhFNyn_l4T99Rqzotv69rjc",
						searchtext: addressQuery,
					},
				})
				.then((response) => {
					const query = response.data.Response.View[0].Result[0].Location.Address.Label;
					const loc = response.data.Response.View[0].Result[0].Location.DisplayPosition;

					let address = { address: query, lat: loc.Latitude, lng: loc.Longitude };
					onSelect(address);
					setQuery(query);

					//save history address when search is done (not saved airport address)
					if (type !== 2) {
						saveHistoryAddressCookie(query, loc.Latitude, loc.Longitude);
					}
				});
		}
		//close modal
		onHide();
	};

	const getCurrentAddress = async () => {
		const options = {
			enableHighAccuracy: true,
			timeout: 5000,
			maximumAge: 0,
		};
		setErrMyPosition(commonErr.LOADING);

		const handleSuccess = async (pos) => {
			const { latitude, longitude } = pos.coords;
			const result = await getAddressFromLatLng(latitude, longitude);
			const addressCurrent = result.data.result ? result.data.result[0].address : "Vị trí của tôi";

			const address = {
				label: addressCurrent,
				lat: latitude,
				lon: longitude,
			};
			setErrMyPosition(commonErr.SUCCESS);
			onSelectLocation(address);
		};

		const handleError = async () => {
			setErrMyPosition(commonErr.SUCCESS);
			setCurrentPosFailed(true);
		};

		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(handleSuccess, handleError, options);
		} else {
			handleError();
		}
	};

	const clearQuery = () => {
		setQuery("");
		setLocationResults([]);
	};

	return (
		<>
			<div className="search-input">
				<div className="wrap-svg">
					<IcSuggestSearch />
				</div>
				<input
					type="text"
					disabled={hidden !== undefined && hidden}
					value={query}
					placeholder={inputProps.placeholder ? inputProps.placeholder : "Nhập địa điểm cụ thể"}
					onChange={(e) => onQuery(e)}
					autoFocus
				/>
				{query.length !== 0 && (
					<div className="wrap-svg pointer" onClick={clearQuery}>
						<IcCloseOrange />
					</div>
				)}
			</div>
			<div className="search-suggest">
				{locationResults.length === 0 ? (
					<LocationDefault
						sd={sd}
						session={session}
						errMyPosition={errMyPosition}
						selectLocation={onSelectLocation}
						getCurrentAddress={getCurrentAddress}
					/>
				) : (
					<>
						{locationResults.map((loc) => (
							<LocationSearch key={loc.id} location={loc} selectLocation={onSelectLocation} />
						))}
					</>
				)}
			</div>
			<MessageBox
				show={currentPosFailed}
				hideModal={() => setCurrentPosFailed(false)}
				message={`Vui lòng cấp quyền truy cập định vị cho trang web để tối ưu tìm kiếm.`}
			/>
		</>
	);
};

const SuggestModal = ({
	show,
	onHide,
	sd,
	getDeliveryAirportId,
	getDeliveryAirportWDId,
	hidden,
	focusAddress,
	locAddress,
	inputProps,
	onSelect,
	carFinding,
	session,
}) => {
	return (
		<Modal show={show} onHide={onHide} dialogClassName="modal-m modal-search modal-fix">
			<Modal.Header closeButton={true} closeLabel={""}>
				<h5>Địa điểm</h5>
			</Modal.Header>
			<Modal.Body>
				<SuggestContent
					sd={sd}
					getDeliveryAirportId={getDeliveryAirportId}
					getDeliveryAirportWDId={getDeliveryAirportWDId}
					hidden={hidden}
					onHide={onHide}
					focusAddress={focusAddress}
					locAddress={locAddress}
					inputProps={inputProps}
					onSelect={onSelect}
					carFinding={carFinding}
					session={session}
				/>
			</Modal.Body>
			{/* <Modal.Footer>
				<div className="wrap-btn">
					<a className="btn btn--s btn-primary" onClick={onHide}>
						Áp dụng
					</a>
				</div>
			</Modal.Footer> */}
		</Modal>
	);
};

const SearchSuggest = ({
	inputProps,
	sd,
	getDeliveryAirportId,
	getDeliveryAirportWDId,
	hidden,
	focusAddress,
	locAddress,
	onSelect,
	carFinding,
	session,
}) => {
	const [showSuggest, setShowSuggest] = useState(false);

	return (
		<div className="here-autocomplete">
			<p
				className={`address pointer ${inputProps.value ? "" : "text-disabled fontWeight-4"}`}
				onClick={() => setShowSuggest(true)}>
				{inputProps.value
					? inputProps.value
					: inputProps?.placeholder
					? inputProps.placeholder
					: "Nhập địa điểm cụ thể"}
			</p>
			<SuggestModal
				show={showSuggest}
				onHide={() => setShowSuggest(false)}
				hidden={hidden}
				sd={sd}
				getDeliveryAirportId={getDeliveryAirportId}
				getDeliveryAirportWDId={getDeliveryAirportWDId}
				focusAddress={focusAddress}
				locAddress={locAddress}
				inputProps={inputProps}
				onSelect={onSelect}
				carFinding={carFinding}
				session={session}
			/>
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		carFinding: state.carFinding,
		session: state.session,
	};
};

export default connect(mapStateToProps)(SearchSuggest);
